import { Link } from 'react-router-dom';
import logo from '../../../../assets/images/informer-logo.png';
import { Button } from '../../../../components/button/button';
import { Container } from '../../../../components/container/container';
import { Input } from '../../../../components/input/input';
import { PasswordInput } from '../../../../components/input/password-input';
import { Message } from '../../../../components/message/message';
import { LangSelect } from '../../../../features/lang-select/lang-select';
import { concatPath } from '../../../../helpers/path';
import { AuthPath, ManagerPath, RootPath } from '../../../../routes/manager/manager-enums';
import s from './login.module.css';
import { useLogin } from './use-login';

export const Login = () => {
  const {
    error,
    handleLogin,
    handleUpdateLoginData,
    loginData,
    t,
    isLoading,
    submitRef,
    handleChangeLang,
  } = useLogin();

  return (
    <div className={s.page}>
      <header className={s.header}>
        <img src={logo} alt="logo" className={s.logo} />
        <h2>{t('Авторизуйтесь')}</h2>
        <label>{t('Это лучшая возможность для использования системы!')}</label>
        <LangSelect className={s.lang} data-testid="lang-select"  onChange={handleChangeLang}/>
      </header>
      <div className={s.inputs}>
        <Container label={t('Логин')}>
          <Input
            value={loginData?.login}
            onChange={(e) => handleUpdateLoginData({ login: e.currentTarget.value })}
            name="username"
            autoComplete="username"
            size="lg"
            data-testid="login-input"
          />
        </Container>
        <Container label={t('Пароль')}>
          <PasswordInput
            value={loginData?.password}
            onChange={(e) => handleUpdateLoginData({ password: e.currentTarget.value })}
            name="password"
            autoComplete="current-password"
            size="lg"
            data-testid="password-input"
          />
        </Container>
        {error && <Message description={t(error)} variant="danger" />}
        <Link
          to={concatPath([RootPath.Manager, ManagerPath.Auth, AuthPath.Restore])}
          className={s.forget}
          data-testid="forget-password"
        >
          {t('Забыли пароль?')}
        </Link>
        <Button
          onClick={handleLogin}
          disabled={isLoading}
          ref={submitRef}
          data-testid="login-button"
        >
          {t('Войти')}
        </Button>
      </div>
      <footer className={s.footer}>Informer Center © 2024 {t('все права защищены')}.</footer>
    </div>
  );
};
